import { render, staticRenderFns } from "./comand-center-contaniner.vue?vue&type=template&id=83f64ff8&scoped=true"
import script from "./comand-center-contaniner.vue?vue&type=script&lang=js"
export * from "./comand-center-contaniner.vue?vue&type=script&lang=js"
import style0 from "./comand-center-contaniner.vue?vue&type=style&index=0&id=83f64ff8&prod&lang=less"
import style1 from "./comand-center-contaniner.vue?vue&type=style&index=1&id=83f64ff8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f64ff8",
  null
  
)

export default component.exports